/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React, { useEffect, useState } from 'react';
import BatchInformationSection from './batchInfo_lotDetails';
import PreparationDataSection from './preparationData';
import DispensingSummaryandFineTuning from './dispensingSummary_fineTuning';
import ValidationAndQualityReleaseSection from './validationAndQualityReleaseSection';
import BatchSidebarSection from './batchSidebarSection';
import MediaPrepHeaderSection from '../../../common/commonComponents/mediaPrepheaderSection';
import MediaPrepPageHeader from '../../../common/commonComponents/mediaPrepPageHeader';
import { useTranslation } from 'react-i18next';
import { mediaPreparationService } from '../../../../service/mediaPrepBatchServices';
import { MediaPowderService } from '../../../../service/MediaPowderServices';
import { useNavigate } from "react-router-dom";
import BatchTraceabilitySection from './batchTraceability';

interface BatchDetailsProps {
  batchId: string;
  onBack: () => void;
  onViewAuditLog?: () => void;
  onViewLotDetails?: (lotId: string, lotSummary?: any) => void;
}

const BatchDetails: React.FC<BatchDetailsProps> = ({ batchId, onBack, onViewAuditLog, onViewLotDetails }) => {
  const { t } = useTranslation();
  const [batchDetails, setBatchDetails] = useState<any>(null);
  const [loading, setLoading] = useState(false);
  const [powderBatch, setPowderBatch] = useState<any>(null);
  const [powderBatchDetails, setPowderBatchDetails] = useState<any>(null);
  const navigate = useNavigate();

  const fetchBatchDetails = async () => {
    setLoading(true);
    try {
      const res = await mediaPreparationService.getMediaBatchDetails(batchId);
      if (res?.status) {
        setBatchDetails(res.data);
      }
    } catch (err) {
      console.error("Error fetching batch details", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (batchId) {
      fetchBatchDetails();
    }
  }, [batchId]);




  const fetchPowderBatch = async () => {
    const batchNumber = batchDetails?.powder_consumption?.[0]?.powder_batch_number;
    if (!batchNumber) return;
    const response = await MediaPowderService.getMediaPowderList(1,10,"id","desc","","",batchNumber);
    if (response?.status && response?.data?.length > 0) {
      setPowderBatch(response.data[0]);
    }
  };

  useEffect(() => {
    if (batchDetails) {
      fetchPowderBatch();
    }
  }, [batchDetails]);




  const fetchPowderBatchDetails = async () => {
    const powderBatchId = powderBatch?.id;
    if (!powderBatchId) return;
    const response =
      await MediaPowderService.getMediaPowderLotDetails(
        powderBatchId
      );
    if (response?.status) {
      setPowderBatchDetails(response);
    }
  };

  useEffect(() => {
    if (powderBatch?.id) {
      fetchPowderBatchDetails();
    }
  }, [powderBatch]);
      

  const batchData = batchDetails;
  const displayBatchId = batchData?.media_batch_identifier || batchId;
  const mediaType = batchData?.media_type || "-";
  const intendedUse = batchData?.intended_use_name || "-";
  const preparedOn = batchData?.created_at || "-";
  const prepared_by = batchData?.lead_technician_name || "-";
  const status = batchData?.status || "-";


  return (
    <div className="media-prep-scope min-h-screen bg-[#F8FAFC] text-slate-900 pb-0">
      <MediaPrepHeaderSection />
      <MediaPrepPageHeader pageHeader={t('mediaPrepBatch.mediaPrepBatchDetails.title')}  />
      {/* Top Navigation / Breadcrumb */}
      <div className="sticky top-[110px] z-50 px-8 py-3 flex items-center justify-between text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 border-b border-slate-200 bg-white backdrop-blur-md">
        <div className="flex items-center gap-2 text-[12px] text-slate-500">
          <button onClick={() => navigate("/dashboard")} 
            className="bg-transparent border-none outline-none shadow-none p-0 text-slate-600 hover:text-slate-900">Home</button>
          <span>&gt;</span>
          <button onClick={onBack} 
            className="bg-transparent border-none outline-none shadow-none p-0 text-slate-600 hover:text-slate-900">{t("mediaPrepBatch.mediaPrepBatchDetails.title")}</button>
          <span>&gt;</span>
          <span className="text-slate-600 font-medium normal-case tracking-normal">{displayBatchId}</span>
        </div>
      </div>

      <div className="max-w-[1440px] mx-auto px-8 py-7">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-2 mb-2 pb-2">
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <h1 className="text-5xl font-black text-slate-900 tracking-tighter uppercase leading-none">
                {displayBatchId}
              </h1>
              <div className="flex flex-col gap-1">
                <span className="px-2 py-0.5 bg-slate-100 text-slate-500 text-[8px] font-black uppercase tracking-[0.2em] rounded border border-slate-200">{status}</span>
              </div>
            </div>
            <div className="flex items-start gap-8 mt-3">
              <div className="pt-0 px-1">
                <p className="text-xs text-slate-500 mb-2">{t('mediaPrepBatch.mediaPrepBatchDetails.MediaType')}</p>
                <p className="text-sm font-semibold whitespace-nowrap">{mediaType}</p>
              </div>
              <div className="w-px h-10 bg-slate-200"></div>
              <div className="border-l border-slate-200 pl-6">
                <p className="text-xs text-slate-500 mb-2">{t('mediaPrepBatch.mediaPrepBatchDetails.IntendedUse')}</p>
                <p className="text-sm font-semibold whitespace-nowrap">{intendedUse}</p>
              </div>
              <div className="w-px h-10 bg-slate-200"></div>
              <div className="border-l border-slate-200 pl-6">
                <p className="text-xs text-slate-500 mb-2">{t("mediaPrepBatch.mediaPrepBatchDetails.Prepared On")}</p>
                <p className="text-sm font-semibold whitespace-nowrap">{preparedOn}</p>
              </div>
              <div className="w-px h-10 bg-slate-200"></div>
              <div className="border-l border-slate-200 pl-6">
                <p className="text-xs text-slate-500 mb-2">{t("mediaPrepBatch.mediaPrepBatchDetails.Prepared By")}</p>
                <p className="text-sm font-semibold whitespace-nowrap">{prepared_by}</p>
              </div>
              <div className="w-px h-10 bg-slate-200"></div>
            </div>
          </div>
          <div className="flex gap-2">
            <button 
              onClick={onViewAuditLog}
              className="flex items-center gap-2 px-3 py-1 whitespace-nowrap bg-white border-2 border-slate-900 rounded-none text-[10px] font-black text-slate-900 uppercase tracking-widest hover:bg-slate-50 transition-all shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none"
            >
              <span className="material-symbols-outlined text-2xl">{t('mediaPrepBatch.icons.history')}</span>
              {t('mediaPrepBatch.mediaPrepBatchDetails.AuditLog')}
            </button>
            <button 
              className="flex items-center gap-2 px-3 py-1 whitespace-nowrap bg-orange-500 border-2 border-slate-900 rounded-none text-[10px] font-black text-white uppercase tracking-widest hover:bg-orange-600 transition-all shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] active:translate-x-[2px] active:translate-y-[2px] active:shadow-none"
            >
              <span className="material-symbols-outlined text-2xl">{t('mediaPrepBatch.icons.print')}</span>
              {t('mediaPrepBatch.mediaPrepBatchDetails.ExportPDF')}
            </button>
          </div>
        </div>
        <div className="w-full h-[1px] bg-slate-700 -mt-2 mb-6"></div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-7 items-start">
          {/* Main Content Area */}
          <div className="lg:col-span-9 space-y-4">
            
            {/* 1. Batch Creation Information */}
            <BatchInformationSection
              batchDetails={batchDetails}
              powderBatchDetails={powderBatch}
               onViewLotDetails={() =>
                  onViewLotDetails?.(powderBatch?.id, {
                    stockStatus: powderBatch?.stock_status,
                    name: powderBatch?.media_name,
                    mf: powderBatch?.manufacturer_name,
                    quantity: powderBatch?.quantity,
                    stock: powderBatch?.available_stock
                  })
                }
              />

            <PreparationDataSection
              displayBatchId={displayBatchId}
              batchDetails={batchDetails}
            />

            <DispensingSummaryandFineTuning
              batchDetails={batchDetails}
            />

          </div>

          {/* Sidebar */}
          <BatchSidebarSection
            batchDetails={batchDetails}
           />
         </div>
         <div className="mt-8">
            <ValidationAndQualityReleaseSection
              batchDetails={batchDetails}
              powderBatchDetails={powderBatchDetails}
            />
         </div>
         <div className="mt-8">
            <BatchTraceabilitySection
              batchDetails={batchDetails}
              powderBatchDetails={powderBatchDetails}
            />
         </div>
        </div>
      </div>
  );
};

export default BatchDetails;
